import React, { useState } from "react";

export default function CampusStudentTable({ campus, students, onViewStudent, onSelectStudentForSOA, selectedStudentsForSOA }) {
  const [localQuery, setLocalQuery] = useState("");
  const filteredStudents = students.filter(student => {
    const query = localQuery.toLowerCase();
    return (
      student.fullname?.toLowerCase().includes(query) ||
      student.name?.toLowerCase().includes(query) ||
      student.id?.toString().includes(query) ||
      student.lrn?.toString().includes(query)
    );
  });

  return (
    <div className="mb-5">
      <h4 className="mb-3">{campus} Students</h4>
      <div className="d-flex justify-content-between align-items-center mb-2">
        <span className="fw-bold">Showing {filteredStudents.length} students</span>
        <input
          type="text"
          className="form-control w-50"
          placeholder={`Search ${campus} students...`}
          value={localQuery}
          onChange={e => setLocalQuery(e.target.value)}
        />
      </div>
      <table className="table table-striped">
        <thead>
          <tr>
            <th>Select</th>
            <th>Student ID</th>
            <th>LRN</th>
            <th>Student Name</th>
            <th>Grade Level</th>
            <th>Section/Strand</th>
            <th>Mode of Payment</th>
            <th>Total Due</th>
            <th>Paid</th>
            <th>Outstanding Due</th>
            <th>Action</th>
          </tr>
        </thead>
        <tbody>
          {filteredStudents.map(student => {
            const isSelected = selectedStudentsForSOA.some(s => s.id === student.id);
            return (
              <tr key={student.id}>
                <td>
                  <input
                    type="checkbox"
                    checked={selectedStudentsForSOA.some((s) => s.id === student.id)}
                    onChange={() => onSelectStudentForSOA(student)}
                  />
                </td>
                <td>{student.id}</td>
                <td>{student.lrn}</td>
                <td>{student.fullname}</td>
                <td>{student.gradeLevel}</td>
                <td>{student.sectionStrand}</td>
                <td>{student.paymentMode}</td>
                <td>{student.totalDue}</td>
                <td>{student.totalPaid}</td>
                <td>{student.outstanding}</td>
                <td>
                  <button
                    className="btn btn-warning btn-sm"
                    onClick={() => onViewStudent(student)}
                  >
                    View
                  </button>
                </td>
              </tr>
            );
          })}
        </tbody>
      </table>
    </div>
  );
}